import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { mergeWith as _mergeWith } from 'lodash-es';
import { assignInWith as _assignInWith } from 'lodash-es';

import { parse } from 'jsonc-parser';

function bootstrapIdabus() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

function getArrayOverwriteMode(element: any) {
  if (typeof element === 'string') {
    if (/^\s*(overwritemode|op)\s*:\s*replace\s*$/i.test(element)) {
      return 'replace';
    } else if (/^\s*(overwritemode|op)\s*:\s*append\s*$/i.test(element)) {
      return 'append';
    } else if (
      /^\s*(overwritemode|op)\s*:\s*(delete|insert|replace)\s*:\s*\d+$/i.test(
        element
      )
    ) {
      const arr = element.split(':');
      return `${arr[1].trim()}:${arr[2].trim()}`;
    }
  }

  return null;
}

function executeMode(mode: string, arrResult: Array<any>, arrMode: Array<any>) {
  if (mode === 'append') {
    return arrResult.concat(arrMode);
  } else if (mode === 'replace') {
    return arrMode;
  } else if (mode.startsWith('insert:')) {
    const pos = parseInt(mode.substring(7));
    arrResult.splice(pos, 0, ...arrMode);
    return arrResult;
  } else if (mode.startsWith('replace:')) {
    const pos = parseInt(mode.substring(8));
    arrResult.splice(pos, 1, ...arrMode);
    return arrResult;
  }
}

if (environment.production) {
  enableProdMode();
}

let customConfigExists = true;
let customConfigValid = true;

const configFileName = `${document.getElementsByTagName('base')[0].href}assets/config/config.${environment.env}.jsonc?t=${new Date().getTime()}`;
fetch(configFileName)
  .then((response) => {
    return response.text();
  })
  .then((txtJson) => {
    const customConfigFileName = `${document.getElementsByTagName('base')[0].href}app/customisation/assets/config/customConfig.${environment.env}.jsonc?t=${new Date().getTime()}`;
    fetch(customConfigFileName)
      .then((customResponse) => {
        if (customResponse.status === 404) {
          customConfigExists = false;
        }
        return customResponse.text();
      })
      .catch(() => {
        customConfigValid = false;
      })
      .then((txtCustomJson) => {
        const json = parse(txtJson);
        if (customConfigExists && txtCustomJson) {
          if (customConfigValid) {
            let config = undefined;
            const customJson = parse(txtCustomJson);
            if (customJson.overwriteMode === 'merge') {
              config = _mergeWith({}, json, customJson, (obj, src) => {
                if (Array.isArray(src) && src.length > 0) {
                  if (obj) {
                    let copy: Array<any> = JSON.parse(JSON.stringify(obj));
                    const srcCopy: Array<any> = JSON.parse(JSON.stringify(src));
                    let previousPos = -1;
                    let previousMode = '';

                    srcCopy.forEach((item: any, index: number) => {
                      const mode = getArrayOverwriteMode(item);
                      if (mode) {
                        if (previousPos > 0 && previousMode) {
                          copy = executeMode(
                            previousMode,
                            copy,
                            srcCopy.slice(previousPos, index)
                          );
                        }
                        if (mode.startsWith('delete')) {
                          previousPos = -1;
                          previousMode = '';
                          copy.splice(parseInt(mode.substring(7)), 1);
                        } else {
                          previousPos = index + 1;
                          previousMode = mode;
                        }
                      }
                    });
                    if (previousPos >= 0 && previousMode) {
                      copy = executeMode(
                        previousMode,
                        copy,
                        srcCopy.slice(previousPos)
                      );
                    }

                    if (getArrayOverwriteMode(src[0])) {
                      return copy;
                    }
                  }

                  // switch (getArrayOverwriteMode(src[0])) {
                  //   case 'replace':
                  //     src.shift();
                  //     return src;
                  //   case 'append':
                  //     src.shift();
                  //     return obj.concat(src);
                  //   case 'merge':
                  //     src.shift();
                  //     break;
                  //   default:
                  //     break;
                  // }
                }
              });
            } else {
              // config = { ...json, ...customJson };
              config = _assignInWith(json, customJson, (obj, src) => {
                if (Array.isArray(src) && src.length > 0) {
                  const mode = getArrayOverwriteMode(src[0]);
                  if (mode) {
                    src.shift();
                    return src;
                  }
                }
              });
            }
            localStorage.setItem('LS_CONFIGURATION', JSON.stringify(config));
          } else {
            localStorage.setItem('LS_CONFIGURATION', 'LS_CONFIGURATIONERROR');
          }
        } else {
          localStorage.setItem('LS_CONFIGURATION', JSON.stringify(json));
        }
        bootstrapIdabus();
      });
  })
  .catch(() => {
    localStorage.setItem('LS_CONFIGURATION', 'LS_CONFIGURATIONERROR');
    bootstrapIdabus();
  });
